import React, { useEffect, useState } from 'react';

import { useGetLibraryConstantsDictionaryData } from '@/providers/ConfigProvider';
import { isBrowser } from '@/helpers/is-browser';
import Button from '../ui/button/button';
import AddIcon from '@/assets/icons/addMobile.svg';
import ThreeDotIcon from '@/assets/icons/threeDotMobile.svg';
import ShareIcon from '@/assets/icons/shareMobile.svg';

interface SafariGuideProps {
  className?: string;
  handleClose?: () => void;
  isMobile?: boolean;
  node_locale: string;
  meetingPlaceName: string;
}

const ICON_TOKENS: Record<string, React.FC<{ className?: string }>> = {
  '{Share Icon}': ShareIcon,
  '{Add Icon}': AddIcon,
  '{Three Dot Icon}': ThreeDotIcon,
};

const renderWithIcons = (text?: string): React.ReactNode => {
  if (!text) return null;

  const tokenPattern = new RegExp(
    `(${Object.keys(ICON_TOKENS)
      .map((token) => token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
      .join('|')})`,
    'g',
  );

  return text.split(tokenPattern).map((part, index) => {
    const Icon = ICON_TOKENS[part];
    if (Icon) {
      return <Icon key={index} className="inline" />;
    }
    return <React.Fragment key={index}>{part}</React.Fragment>;
  });
};

export const SafariGuide = ({
  className,
  node_locale,
  handleClose,
  isMobile = false,
  meetingPlaceName,
}: SafariGuideProps) => {
  const dictionary = useGetLibraryConstantsDictionaryData();

  return (
    <>
      {!isMobile ? (
        <>
          <div className="text-headingm font-title gap-4 text-neutral-grey-700">
            {dictionary?.pwaDesktopSafariGuideHeader?.replace(
              '{Meeting Place}',
              meetingPlaceName,
            )}
          </div>
          <div className="flex mt-4 flex-col gap-2">
            <div className="text-neutral-grey-400 font-sans text-bodyl">
              {dictionary?.pwaDesktopSafariGuide1}
            </div>
            <div className="text-neutral-grey-400 font-sans text-bodyl">
              {renderWithIcons(dictionary?.pwaDesktopSafariGuide2)}
            </div>
            <div className="text-neutral-grey-400 font-sans text-bodyl">
              {dictionary?.pwaDesktopSafariGuide3}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="text-headingm font-title gap-4 text-neutral-grey-700">
            {dictionary?.pwaDesktopSafariGuideHeader?.replace(
              '{Meeting Place}',
              meetingPlaceName,
            )}
          </div>
          <div className="flex mt-4 flex-col gap-2">
            <div className="text-neutral-grey-400 font-sans text-bodyl">
              {renderWithIcons(dictionary?.pwaMobileSafariGuide1)}
            </div>
            <div className="text-neutral-grey-400 font-sans text-bodyl">
              {renderWithIcons(dictionary?.pwaMobileSafariGuide2)}
            </div>
            <div className="text-neutral-grey-400 font-sans text-bodyl">
              {renderWithIcons(dictionary?.pwaMobileSafariGuide3)}
            </div>
          </div>
          <div className="button-container flex flex-col gap-4 mt-6">
            <Button variant="primary" onClick={handleClose}>
              {dictionary?.close || 'Close'}
            </Button>
          </div>
        </>
      )}
    </>
  );
};
